import { Component, NgZone } from "@angular/core";
import { NavController, NavParams, ModalController } from "ionic-angular";

import { APIServiceProvider } from "./../../../common/services/api.service";
import { HelperServiceProvider } from "./../../../common/services/helper.service";

import { OrderdetailsModalPage } from "../../../modals/orderdetails/orderdetails.modal";

@Component({
	selector: "page-inventorypendingprocurement",
	templateUrl: "inventorypendingprocurement.html"
})
export class InventoryPendingProcurementPage {
	constructor(
		public navCtrl: NavController,
		public helperService: HelperServiceProvider,
		public navParams: NavParams,
		public zone: NgZone,
		public modalController: ModalController,
		public apiHelper: APIServiceProvider
	) {}

	public postParams: any = {
		transaction_type: "inward",
		manager_id: localStorage.getItem("manager_user_id")
	};

	public inventories: any = [];
	public pagination = null;
	public searchText = null;

	public inventorypending = "inventory/get-pending-transactions";

	ionViewDidLoad() {
		this.getInventories(this.inventorypending);
	}

	showOrderDetailsModal(order_id) {
		this.getOrderDetails(order_id).then(data => {
			let modalObject = this.modalController.create(
				OrderdetailsModalPage,
				{
					orderDetails: data
				}
			);

			modalObject.present();
		});
	}

	getOrderDetails(order_id) {
		return new Promise((resolve, reject) => {
			const params = {
				order_id,
				manager_id: localStorage.getItem("manager_user_id")
			};
			this.apiHelper
				.post("orders/get-order-details", params)
				.subscribe(result => {
					resolve(result);
				});
		});
	}

	getInventories(url, refresh?) {
		this.apiHelper.post(url, this.postParams).subscribe(
			response => {
				this.inventories = response["data"]["data"];
				this.pagination = response["data"];
				if (refresh) {
					refresh.complete();
				}
			},
			error => {}
		);
	}

	doRefresh(refresher) {
		this.getInventories(this.inventorypending, refresher);
	}

	doInfiniteScroll(event) {
		if (
			!this.pagination.next_page_url ||
			this.pagination.next_page_url === "" ||
			this.pagination.next_page_url === null ||
			this.pagination.next_page_url === "null"
		) {
			event.complete();
			return;
		} else {
			this.apiHelper
				.post(null, this.postParams, this.pagination["next_page_url"])
				.subscribe(
					response => {
						this.inventories = this.inventories.concat(
							response["data"]["data"]
						);
						this.pagination = response["data"];
						event.complete();
					},
					error => {}
				);
			return;
		}
	}

	search(text) {
		this.postParams["search"] = this.searchText;
		this.getInventories(this.inventorypending);
	}

	clearSearch(text) {
		delete this.postParams["search"];
		this.getInventories(this.inventorypending);
	}
}



// WEBPACK FOOTER //
// ./src/pages/inventory/inventorypendingprocurement/inventorypendingprocurement.ts